import React from 'react';
import './PDPImmersiveExperience.scss';

const PDPImmersiveExperience = ({
  anchor = 'immersive-experience',
  icon,
  heading,
  featuredImage,
  features,
}) => {
  return (
    <>
      {anchor && <a id={anchor} />}
      <div className="c-pdp-immersive-experience background-color-white">
        <div className="c-pdp-immersive-experience__content-wrapper">
          <div className="c-pdp-immersive-experience__content">
            <img src={icon.url} alt={icon.alt} className="c-pdp-immersive-experience__icon" />
            <h4 className="c-pdp-immersive-experience__heading h4-right-grotesk color-black">
              {heading}
            </h4>
            <div className="c-pdp-immersive-experience__features">
              {features.map((feature) => (
                <div className="c-pdp-immersive-experience__feature body-1 color-black">
                  {feature}
                </div>
              ))}
            </div>
          </div>
          <div className="c-pdp-immersive-experience__featured-img-container">
            <img
              src={featuredImage.url}
              alt={featuredImage.alt}
              className="c-pdp-immersive-experience__featured-img"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PDPImmersiveExperience;
